import auth from '@/auth'
import { vm } from '@/main'
import { Dispatcher } from '@/APIDispatcher'

export const UserApi = {
  accountLogin (email, password, path) {
    Dispatcher.post('account/login',
      { email: email, password: password }).then(s => {
      if (s.errorCode === 'SUCCESS') {
        auth.login(s)

        if(path) {
          vm.$router.push(path)
        } else {
          vm.$router.push('/dashboard')
        }
      } else {
        vm.$notify.error('Login Failed', 'Please try again')
      }
    })
  }
}

export const MiscApi = {
  getCountryList () {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('countries/list', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('List Failed', 'Country list failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  getGlobalConfig () {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('config/get', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.config)
        } else {
          vm.$notify.error('Config Get Failed')
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  saveGlobalConfig (config) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('config/set', { config }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('Config Set Failed')
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  getContractList(opts = {}) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('contracts/list', opts).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.list)
        } else {
          vm.$notify.error('List Failed', 'Contract list failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  getContractsBySeller(sid) {
    return this.getContractList({ seller_id: sid })
  },
  getContractsByBuyer(bid) {
    return this.getContractList({ buyer_id: bid })
  },
  contractSave(contract) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('contract/set', { contract }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.contract)
        } else {
          vm.$notify.error('Contract Save Failed', 'Contract save failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/api.js